<template>
    <div class="recruit-page">
        <div class="block recruit-block">
            <router-link v-for="(jd, index) in jdList" :key="index" :to="{ name: 'jd', query: { id: jd.recruitmentId } }" class="recruit-item">
                <div class="left-area">
                    <h6>{{isCn?jd.cnJobName:jd.enJobName}}</h6>
                    <small>{{isCn?jd.cnWorkplace:jd.enWorkplace}}</small>
                    <p><span>{{isCn?jd.cnEducationRequirement:jd.enEducationRequirement}}</span><span>{{isCn?jd.cnWorkYears:jd.enWorkYears}}</span></p>
                </div>
                <div class="right-area">
                    <strong>{{isCn?jd.cnSalaryRange:jd.enSalaryRange}}</strong>
                </div>
            </router-link>
            <div class="more-row" v-show="!isMore">
                <span class="btn-more" @click="moreSub">{{lang.spread}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'aboutRecruit',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            jdList: [],
            page: 1,
            isMore: false,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        getList() {
            ajax.get('/web/about_us/recruitment_list.json', { page: this.page, pageSize: 5 }).then((result) => {
                this.jdList = this.jdList.concat(result.dataList);
                this.isMore = result.totalPage <= this.page;
                this.page += 1;
            }).catch(() => {});
        },
        moreSub() {
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px;
    }
    .recruit-item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-bottom: 12px;
        border-bottom: 1px solid #F1F1F1;
        .left-area {
            flex: 0 0 70%;
            text-align: left;
        }
        .right-area {
            flex: 0 0 30%;
            text-align: right;
        }
        strong {
            display: block;
            word-break: break-word;
            color: #C71F4B;
            font-size: 14px;
            font-weight: 600;
            margin-top: 8px;
        }
        h6 {
            word-break: break-word;
            padding-top: 8px;
            font-weight: 600;
        }
        small {
            display: block;
            word-break: break-word;
            line-height: 20px;
            color: #9B9B9B;
            font-size: 12px;
        }
        p {
            padding-top: 8px;
            word-break: break-word;
            & > span {
                margin-right: 12px;
                padding: 5px 10px;
                font-size: 12px;
                background: #F1F1F1;
                color: #C1C1C1;
            }
        }
    }
    .more-row {
        padding-top: 16px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
</style>
